/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/rtrim.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Removes trailing whitespaces from a string.
 *
 * @example
 * ROW message = "   some text  ",  color = " red "
 * | EVAL message = RTRIM(message)
 * | EVAL color = RTRIM(color)
 * | EVAL message = CONCAT("'", message, "'")
 * | EVAL color = CONCAT("'", color, "'")
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'rtrim',
  signatures: [
    {
      params: [
        {
          name: 'string',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'string',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: false,
  snapshotOnly: false,
};

export default definition;
